import { motion } from "framer-motion";

const HERO_VIDEO = "https://videos.pexels.com/video-files/4763824/4763824-uhd_2560_1440_24fps.mp4";
const FALLBACK_IMG =
    "https://images.pexels.com/photos/23384400/pexels-photo-23384400.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920";

export default function Hero() {
    return (
        <section data-testid="hero" className="relative h-[100svh] w-full overflow-hidden">
            <div className="absolute inset-0 w-full h-full overflow-hidden">
                <iframe
                    data-testid="hero-video"
                    src="https://player.vimeo.com/video/1185081520?background=1&autoplay=1&loop=1&muted=1&autopause=0#t=60s"
                    title="Clavados — Travis Birds"
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[177.78vh] min-w-full h-[56.25vw] min-h-full pointer-events-none"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                />
            </div>
            <div className="absolute inset-0 bg-black/55" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black" />

            <div className="relative z-10 h-full flex flex-col">
                <div className="flex-1 flex items-end px-6 md:px-12 pb-16 md:pb-24">
                    <div className="max-w-6xl">
                        <motion.h1
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 0.35 }}
                            className="font-display tracking-tightest leading-[0.78] text-[56px] sm:text-[96px] md:text-[140px] lg:text-[180px]"
                        >
                            Create
                            <br />
                            to<span className="text-[color:var(--midi-accent-strong)] ml-[0.18em]">share</span>
                            <span className="text-white">.</span>
                        </motion.h1>
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1.2, delay: 0.9 }}
                            className="mt-8 md:mt-12 max-w-xl text-white/75 text-base md:text-lg font-light leading-relaxed"
                        >
                            No producimos vídeos. Producimos historias capaces de generar
                            <span className="text-white"> cultura, conversación y emoción.</span>
                        </motion.p>
                    </div>
                </div>

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 0 }}
                    transition={{ duration: 0 }}
                    className="hidden"
                />
            </div>
        </section>
    );
}
